import { formatMoney } from 'services/util'

import themeCss from '../components/sass/theme.module.scss'
import adminCss from './sass/adminpage.module.scss'
import DonationLinkCopyButton from './DonationLinkCopyButton'

export default function DonationDisplay({ auction }) {
  const donationRegistrations = (auction?.Registrations || [])
    .filter((registration) => Number(registration?.DonationTotal) > 0)
    .map((registration) => {
      const firstName = registration?.User?.FirstName || ''
      const lastName = registration?.User?.LastName || ''
      const fullName = `${firstName} ${lastName}`.trim() || 'Unknown Attendee'

      return {
        ...registration,
        AttendeeName: fullName,
      }
    })

  if (!auction.HasDonation) return <></>


  return (
    <div>
      <div className={adminCss['admin-donation-row']}>
        <h3 className={adminCss['admin-auction-page-tab-header']}>Donations</h3>
        <DonationLinkCopyButton auction={auction} />
      </div>

      {donationRegistrations.length === 0 ? (
        <p>No donations have been made for this auction yet.</p>
      ) : (
        <table className={themeCss['data-table']}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Donation Total</th>
            </tr>
          </thead>
          <tbody>
            {donationRegistrations.map((registration) => (
              <tr key={registration.RegistrationId}>
                <td>{registration.AttendeeName}</td>
                <td>${formatMoney(registration.DonationTotal)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
